import { auth } from "../firebase";

const BASE = (
  process.env.REACT_APP_PAYROLL_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL_PROD ||
  process.env.REACT_APP_BACKEND_URL ||
  "http://localhost:8000"
).replace(/\/$/, "");

async function request(company, path, { body, method = "GET", signal } = {}) {
  const endpoint = new URL(BASE);
  if (
    endpoint.protocol !== "https:" &&
    !["localhost", "127.0.0.1", "[::1]"].includes(endpoint.hostname)
  ) {
    throw new Error("Payroll requires a secure HTTPS connection.");
  }
  const user = auth.currentUser;
  if (!user) throw new Error("Sign in to open payroll.");
  const token = await user.getIdToken();
  const response = await fetch(
    `${BASE}/payroll/${encodeURIComponent(company)}${path}`,
    {
      method,
      signal,
      cache: "no-store",
      credentials: "omit",
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    },
  );
  let data;
  try {
    data = await response.json();
  } catch (_) {
    if (response.ok)
      throw new Error("The payroll backend returned an unexpected response.");
    data = {};
  }
  if (!response.ok) {
    const error = new Error(
      typeof data.detail === "string"
        ? data.detail
        : "Payroll is unavailable. Try again.",
    );
    error.status = response.status;
    throw error;
  }
  return data;
}

export const payrollService = {
  load: (company, signal) => request(company, "/workspace", { signal }),
  save: (company, body) =>
    request(company, "/workspace", { method: "PUT", body }),
  connect: (company, body) =>
    request(company, "/connection", { method: "POST", body }),
  disconnect: (company, revision) =>
    request(company, "/connection/disconnect", {
      method: "POST",
      body: { revision },
    }),
  submit: (company, body) =>
    request(company, "/submissions", { method: "POST", body }),
  status: (company, run) =>
    request(company, `/submissions/${encodeURIComponent(run)}/status`, {
      method: "POST",
    }),
  breakdown: (company, period) =>
    request(company, `/months/${encodeURIComponent(period)}/breakdown`),
  activity: (company) => request(company, "/activity"),
};
